import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { Edition } from '../common/editions';
import { ExpressCtaDialogService } from '../navigable-app/express-cta-dialog/express-cta-dialog.service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ProEditionGuard {
  constructor(
    private appConfigService: AppConfigService,
    private upgradeService: ExpressCtaDialogService,
    private snowplowService: ProductAnalyticsService,
    private translateService: TranslateService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.appConfigService.appConfig.pipe(
      map((config) => {
        const isPro = config.edition === Edition.Pro;
        if (!isPro) {
          const urlTree = this.router.parseUrl(state.url);
          const segments = urlTree.root.hasChildren() ? urlTree.root.children.primary.segments : null;
          const lastSegment = segments ? segments[segments.length - 1] : 'nav';

          const clickTrackingLabel = `${lastSegment}-upgrade-express-cta`;
          this.upgradeService.open(
            // TODO: Use a better image after figuring out how to resize the image properly.
            'https://vstatic-prod.apigateway.co/customer-voice-client.9223372035066326780.prod/assets/images/express_cta/kiosk.png',
            'EXPRESS_CTA_DIALOG.IMAGE_TEXT.MOBILE_KIOSK',
            `${clickTrackingLabel}-upgraded`,
            [
              this.translateService.instant('EXPRESS_CTA_DIALOG.KEY_SELLING_POINTS.MOBILE_KIOSK'),
              this.translateService.instant('EXPRESS_CTA_DIALOG.KEY_SELLING_POINTS.UNLIMITED_EMAIL'),
              this.translateService.instant('EXPRESS_CTA_DIALOG.KEY_SELLING_POINTS.SMS_ADDONS'),
              this.translateService.instant('EXPRESS_CTA_DIALOG.KEY_SELLING_POINTS.40_TEMPLATES'),
              this.translateService.instant('EXPRESS_CTA_DIALOG.KEY_SELLING_POINTS.MORE_REVIEW_SITES'),
              this.translateService.instant('EXPRESS_CTA_DIALOG.KEY_SELLING_POINTS.BULK_SEND'),
            ],
          );
        }

        return isPro;
      }),
    );
  }
}
